<template>
    <div
        class="p-4 fixed inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center z-50"
        @touchmove.stop
        @click.self="close"
    >
        <div class="bg-white pb-9 rounded-lg w-full max-w-screen-xl max-h-full relative flex flex-col">
            <button class="border-none bg-white absolute rounded-full top-4 right-4 md:top-8 md:right-8" @click="close">
                <img src="@/assets/img/close.svg" alt="Close" class="size-9" />
            </button>

            <div class="flex-grow overflow-y-auto">
                <div class="pt-9 px-4 md:px-9 pr-20">
                    <h2
                        class="text-2xl md:text-4xl font-semibold mb-3"
                        v-html="currentSlide.title"
                    ></h2>
                    <h3
                        v-if="currentSlide.subtitle"
                        class="text-base md:text-2xl font-semibold text-lightblue"
                        v-html="currentSlide.subtitle"
                    ></h3>
                </div>

                <div class="my-6 px-4 md:px-9">
                    <component :is="currentSlide.content" />
                </div>

                <div v-if="hasMultipleSlides" class="mt-4 px-9 flex justify-end gap-4">
                    <button
                        v-if="currentSlide.nextButtonTitle"
                        class="bg-green text-gray-800 font-semibold py-4 px-8 shadow flex items-center space-x-2 rounded-full"
                        @click="nextSlide"
                    >
                        <span>{{ currentSlide.nextButtonTitle }}</span>
                        <img
                            v-if="currentSlide.nextButtonIcon"
                            class="inline-block h-4 w-4"
                            :src="currentSlide.nextButtonIcon"
                        />
                        <img
                            v-else
                            class="inline-block h-4 w-4"
                            src="@/assets/img/right_arrow.svg"
                            alt="Right arrow icon"
                        />
                    </button>

                    <button
                        v-if="currentSlide.previousButtonTitle"
                        class="bg-green text-gray-800 font-semibold py-4 px-8 shadow flex items-center space-x-2 rounded-full"
                        @click="previousSlide"
                    >
                        <img class="inline-block h-4 w-4 rotate-180" src="@/assets/img/right_arrow.svg" />
                        <span>{{ currentSlide.previousButtonTitle }}</span>
                    </button>
                </div>

                <div class="px-9 mt-2">
                    <p v-if="currentSlide.references" class="text-xs font-light" v-html="currentSlide.references"></p>
                    <JobCode />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import JobCode from './JobCode.vue';

const props = defineProps({
    cta: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close']);

const slideIndex = ref(0);

const hasMultipleSlides = computed(() => props.cta.slides.length > 1);
const currentSlide = computed(() => props.cta.slides[slideIndex.value]);

onMounted(() => {
    document.body.classList.add('no-scroll'); // Disable scrolling
});

function nextSlide() {
    slideIndex.value += 1;
}

function previousSlide() {
    slideIndex.value -= 1;
}

function close() {
    emit('close');
    // Enable scrolling
    document.body.classList.remove('no-scroll');
}
</script>

<style>
.no-scroll {
    overflow: hidden;
}
</style>
